module.exports = __webpack_public_path__ + "static/media/jane_levy.18caba8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/jane_levy.jpg
// module id = 217
// module chunks = 0